interface FilePreviewProps {
    file?: File;
    content?: string;
}

const FilePreview = ({ file, content }: FilePreviewProps) => (
    <div
        className={`mt-15 width-100pct overflow-y-auto bg-white p-20 ${!file && 'display-flex align-items-center justify-content-center'}`}
    >
        <div className=''>{content ?? 'No file to preview'}</div>
    </div>
);

export default FilePreview;
